import React from "react";

// App
import { ApiPath, Field, Notice, Section, TagList } from "./apiField";

const formatHours = (slot) => {
  const days = [slot.fromDay, slot.toDay].filter(Boolean);
  const dayLabel = days.length
    ? days.join(slot.prep ? ` ${slot.prep} ` : " to ")
    : "";
  const times = [slot.from, slot.to].filter(Boolean).join(" - ");
  return [dayLabel, times].filter(Boolean).join(", ");
};

export default function DiningSection({ outlets, raw }) {
  return (
    <Section
      id="dining"
      title="Food & beverage"
      subtitle={`${outlets.length} outlet${outlets.length === 1 ? "" : "s"}`}
      path="restaurants.collection[]"
      raw={raw}
    >
      {!outlets.length ? (
        <Notice tone="warn">No outlets.</Notice>
      ) : (
        <div className="rhp-outlets">
          {outlets.map((outlet) => (
            <article className="rhp-outlet" key={outlet.index}>
              {outlet.hero ? (
                <div className="rhp-outlet__media">
                  <img src={outlet.hero} alt={outlet.name} loading="lazy" />
                  <ApiPath path={outlet.heroPath} />
                </div>
              ) : null}

              <div className="rhp-outlet__body">
                <header>
                  <h3>
                    {outlet.name}
                    {outlet.isBreakfast ? (
                      <span className="rhp-badge">Breakfast venue</span>
                    ) : null}
                  </h3>
                  <ApiPath path={outlet.namePath} />
                </header>

                {outlet.headline && outlet.headline !== outlet.name ? (
                  <p className="rhp-outlet__headline">{outlet.headline}</p>
                ) : null}
                {outlet.description ? (
                  <p className="rhp-outlet__description">
                    {outlet.description}
                  </p>
                ) : null}

                <h4 className="rhp-subhead rhp-subhead--sm">Cuisine</h4>
                <TagList items={outlet.cuisine} path={outlet.cuisinePath} />

                <h4 className="rhp-subhead rhp-subhead--sm">
                  Service & dietary
                </h4>
                <TagList items={outlet.services} path={outlet.servicesPath} />

                <h4 className="rhp-subhead rhp-subhead--sm">Opening hours</h4>
                {outlet.hours.length ? (
                  <div className="rhp-hours">
                    {outlet.hours.map((slot, i) => (
                      <div className="rhp-hours__row" key={i}>
                        <span className="rhp-hours__type">
                          {slot.type || "Opening"}
                        </span>
                        <span className="rhp-hours__time">
                          {formatHours(slot) || "—"}
                        </span>
                        {slot.note ? (
                          <span className="rhp-hours__note">{slot.note}</span>
                        ) : null}
                      </div>
                    ))}
                    <ApiPath path={outlet.hoursPath} />
                  </div>
                ) : (
                  <TagList items={[]} path={outlet.hoursPath} />
                )}

                <div className="rhp-grid rhp-grid--tight">
                  <Field
                    label="Floor"
                    value={outlet.floor}
                    path={outlet.floorPath}
                  />
                  <Field
                    label="Phone"
                    value={outlet.phone}
                    path={outlet.phonePath}
                  />
                  <Field
                    label="Email"
                    value={outlet.emailLink}
                    path={outlet.emailLinkPath}
                  />
                  <Field
                    label="Reservations"
                    value={outlet.bookLink}
                    path={outlet.bookLinkPath}
                  >
                    {outlet.bookLink ? (
                      <a
                        href={outlet.bookLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {outlet.bookLabel}
                      </a>
                    ) : null}
                  </Field>
                </div>

                {outlet.menus.length ? (
                  <>
                    <h4 className="rhp-subhead rhp-subhead--sm">Menus</h4>
                    <div className="rhp-tags">
                      {outlet.menus.map((menu) => (
                        <a
                          className="rhp-tag rhp-tag--link"
                          key={menu.url}
                          href={menu.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {menu.label}
                        </a>
                      ))}
                    </div>
                    <ApiPath path={outlet.menusPath} />
                  </>
                ) : null}

                {outlet.images.length ? (
                  <>
                    <h4 className="rhp-subhead rhp-subhead--sm">
                      Outlet gallery
                    </h4>
                    <div className="rhp-thumbs">
                      {outlet.images.slice(0, 8).map((img, i) => (
                        <a
                          key={`${outlet.index}-${i}`}
                          href={img.binaryContent.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={
                              img.externalContent?.metadata?.urlThumbnail ||
                              img.binaryContent.url
                            }
                            alt={img.metadata?.altText || outlet.name}
                            loading="lazy"
                          />
                        </a>
                      ))}
                    </div>
                    <ApiPath path={outlet.imagesPath} />
                  </>
                ) : null}
              </div>
            </article>
          ))}
        </div>
      )}
    </Section>
  );
}
